/* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';
import classnames from 'classnames';

import helper from '../../helpers';
import utils from '../../../../lib/utils';
import Loading from '../../../common/Loading';
import './index.scss';

Modal.setAppElement('#root');

const validateTagName = (value = '') => {
  const trimmed = value.trim();
  return /^(?=.*[A-Za-z])[A-Za-z0-9 -]+$/.test(trimmed);
};

class CreateTagOverlay extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.addCustomTag = this.addCustomTag.bind(this);
    this.addTagName = this.addTagName.bind(this);
    this.deleteTag = this.deleteTag.bind(this);
    this.state = {
      customtags: [],
      tagName: '',
      max_no_of_tags: 10,
      deletingTagId: null,
    };
  }

  componentDidMount() {
    this.props.getCustomTags();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.conversations.deleteTags !== nextProps.conversations.deleteTags && !nextProps.conversations.deleteTags) {
      this.setState({ deletingTagId: null });
    }
  }

  closeModal() {
    this.props.setTagOverlayVisibility(false);
    this.props.clearReportFlags();
    this.setState({
      phone: '',
      unblockingnumber: '',
      error: false,
    });
  }

  addCustomTag() {
    const { tagName, customtags } = this.state;
    this.setState({
      customtags: [...customtags, tagName.trim()],
      tagName: '',
    });
    this.props.addCustomTags({ 'tag_name': tagName.trim() });
  }

  addTagName(event) {
    let value = event.target.value;

    // Allow only alphanumeric, space, hyphen
    value = value.replace(/[^a-zA-Z0-9 -]/g, '');

    // Remove leading/trailing spaces
    value = value.replace(/^\s/g, '');

    // Max length 15
    value = value.slice(0, 15);

    this.setState({ tagName: value });
  }

  deleteTag(id) {
    if (!this.state.deletingTagId) {
      this.props.deleteCustomTag({ 'id': id });
      this.setState({ deletingTagId: id });
    }
  }

  render() {
    const { modelopen, conversations } = this.props;
    const { tagName, customtags, max_no_of_tags, deletingTagId } = this.state;
    const { custom_tags, getCustomTag, addTags, deleteTag } = conversations;
    console.log('tagName', tagName, customtags);
    const features = utils.getCookie('feature');
    const trimmedTag = tagName.trim();
    const isValidTag = validateTagName(tagName);

    const isDisabled =
      trimmedTag.length < 1 ||
      !isValidTag ||
      custom_tags.length >= max_no_of_tags ||
      getCustomTag;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          shouldCloseOnOverlayClick
          preventScroll={false}
          className="TagModal"
          overlayClassName="overlay-top"
          contentLabel="Example Modal"
        >
          <div>
            <div>
              <div className="modal-header">
                <div className="title">Custom Tags</div>
                <button className="modal-close" onClick={this.closeModal}><i className="material-icons">close</i></button>
                <div className="sub-title">You can define up to <span>10 custom tags</span> for conversation tagging.</div>
                <div className="input">
                  <div className="block-number">
                    <input className="tag-name" type="text" onChange={this.addTagName} value={tagName} placeholder="New Tag" />
                    <button className={classnames('btn btn--primary add-btn', { disabled: isDisabled })} onClick={this.addCustomTag} disabled={isDisabled}>{addTags ? 'ADDING...' : 'ADD TAG'}</button>
                  </div>
                  {tagName.length > 0 && !isValidTag && <div className="error-message">Atleast one character should be alphabet.</div>}
                  {custom_tags.length >= max_no_of_tags && <div className="error-message">You have reached max number of tags</div>}
                </div>
                <div className="note"><span>Note:</span> Tag name must be under 15 characters, can include letters, numbers, spaces, and hyphens, and cannot be only numbers.</div>
              </div>

              <div className="blocked-list">
                <div className="tag-list-content">
                  {custom_tags.map((tag, index) => {
                    return (<div key={index} className="phone-number"><div className="phone-number_number">{tag.name}</div><div className="phone-number_unblock" onClick={() => this.deleteTag(tag.id)}>{deletingTagId === tag.id ? 'Removing...' : 'Remove'}</div></div>);
                  })
                  }
                </div>
              </div>
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default CreateTagOverlay;
